var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStopLinePaymentMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "108px",
    viewBox: "0 0 12 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0B6D46FA-B1F9-4800-97AA-F98634E12645") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KLM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KLM/Flightcard/Mobile/Transfer/Details",
    transform: "translate(-23, -63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flightconnector/Vertical/Medium/Transfer",
    transform: "translate(23, 63)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -43.5,
    y1: 53.5,
    x2: 55.5,
    y2: 53.5,
    id: "Path",
    stroke: "#00A1DE",
    strokeWidth: 2,
    transform: "translate(6, 53.5) rotate(90) translate(-6, -53.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#00A1DE",
    cx: 6,
    cy: 54,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#00A1DE",
    fill: "#FFFFFF",
    transform: "translate(6, 5) rotate(90) translate(-6, -5)",
    cx: 6,
    cy: 5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    stroke: "#00A1DE",
    fill: "#FFFFFF",
    transform: "translate(6, 103) rotate(90) translate(-6, -103)",
    cx: 6,
    cy: 103,
    r: 4.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopLinePaymentMobile);
export default __webpack_public_path__ + "static/media/stop-line-payment-mobile.753a6be9478c8d42341f50e93033eda8.svg";
export { ForwardRef as ReactComponent };